// extracted by mini-css-extract-plugin
export default {"title":"Lable_title__gpafH"};